import { render, staticRenderFns } from "./OrderTab.vue?vue&type=template&id=dc81cb14&scoped=true&"
import script from "./OrderTab.vue?vue&type=script&lang=js&"
export * from "./OrderTab.vue?vue&type=script&lang=js&"
import style0 from "./OrderTab.vue?vue&type=style&index=0&id=dc81cb14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc81cb14",
  null
  
)

component.options.__file = "OrderTab.vue"
export default component.exports